import { ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthCustomService } from './auth-custom.service';

@Injectable()
export class AuthGuard {
  token: string | undefined;
  user: any;
  jwtPayload!: any;
  constructor(private authCustom: AuthCustomService, private router: Router) {}
  async canActivate(next: ActivatedRouteSnapshot): Promise<boolean> {
    const isAuthenticated = await this.authCustom.isAuthenticatedResolved();
    if (!isAuthenticated) {
      this.router.navigate(['welcome']);
      return false;
    }

    const token = await this.authCustom.ensureToken();

    if (token && this.authCustom.hasValidToken()) {
      const roles: string[] = next.data['roles'];
      // se nao precisa de permissao ?
      if (roles === undefined || roles.length === 0) {
        return true;
      }
      // tem permissao ?
      if (this.authCustom.somePermission(roles)) {
        return true;
      }
      this.router.navigate(['/unauthorized']);
      return false;
    }

    this.router.navigate(['welcome']);
    return false;
  }
}
